const REMOTE_URL_PATTERN = /^https?:\/\//i;

const EVENT_PHOTO_STORAGE_PREFIXES = [
  '/storage/v1/object/public/event-photos/',
  '/storage/v1/object/sign/event-photos/',
  '/storage/v1/object/authenticated/event-photos/',
];

export const getAdventureCoverFromEventImage = (value: string | null | undefined) => {
  if (!value) return null;

  const normalized = value.trim();
  if (!normalized) return null;

  if (!REMOTE_URL_PATTERN.test(normalized)) {
    return null;
  }

  try {
    const pathname = new URL(normalized).pathname;
    if (EVENT_PHOTO_STORAGE_PREFIXES.some((prefix) => pathname.includes(prefix))) {
      return null;
    }
  } catch {
    return null;
  }

  return normalized;
};
